<template>
  <div
    class="tab-container"
    v-bind:class="{
      selectable: !selected,
      'left-tab': left,
      'right-tab': right,
    }"
  >
    <div class="tab-title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'tab',
  props: {
    title: String,
    left: Boolean,
    right: Boolean,
    selected: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.tab-container {
  width: calc(25% - 62px);
  height: 90px;
  background-color: $primary-100;
  margin-right: 7px;
  padding-top: 24px;
  padding-left: 37px;
  transition: 0.3s;
}
.tab-container.selectable {
  cursor: pointer;
  border-color: $primary-700;
  border-style: solid;
  border-width: 0;
  border-bottom-width: 7px;
  opacity: 0.5;
}
.left-tab {
  border-top-left-radius: 6px;
}
.right-tab {
  border-top-right-radius: 6px;
}
.tab-title {
  font-weight: 700;
  font-size: 28px;
}
span {
  border-bottom: solid 5px rgba(96, 104, 154, 0.208);
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  .tab-container {
    width: 180px;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  .tab-container {
    width: 33%;
    min-width: 110px;
    padding-top: 17px;
    padding-left: 22px;
    height: 70px;
  }
  .tab-title {
    font-size: 20px;
  }
}
</style>
